import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "./AuthContext";

export function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  const isGuestShareLink = (() => {
    try {
      const hash = location.hash || "";
      // Hash format: #room=<id>,<key>&guest=<token>
      // Extract guest token using regex instead of URLSearchParams
      const guestMatch = hash.match(/[&?]guest=([a-zA-Z0-9._-]+)/);
      const roomMatch = hash.match(/#room=([a-zA-Z0-9_-]+),([a-zA-Z0-9_-]+)/);
      const isGuest = !!(guestMatch && roomMatch);
      if (isGuest) {
        console.log("[ProtectedRoute] Guest share link detected:", { hash, guestToken: guestMatch[1].substring(0, 20) + "..." });
      }
      return isGuest;
    } catch {
      return false;
    }
  })();

  if (loading) {
    return null;
  }

  if (!isAuthenticated) {
    // Allow guests to join when the tutor generated a guest share link.
    if (isGuestShareLink) {
      return children;
    }

    const next = location.pathname + location.search + location.hash;
    try {
      sessionStorage.setItem("postLoginRedirect", next);
    } catch {
      // ignore
    }
    return <Navigate to="/login" replace state={{ from: next }} />;
  }

  return children;
}
